// Sets `data-dragging` on the element while files are dragged over it, as a JS command so
// re-renders keep it. LiveView takes the drop itself (`phx-drop-target`).

const hasFiles = e => e.dataTransfer?.types.includes('Files');

export default {
  FileDropZone: {
    mounted() {
      // dragenter and dragleave also fire when crossing into a child, so count them.
      let depth = 0;

      this.el.addEventListener('dragenter', e => {
        if (hasFiles(e) && depth++ === 0) this.js().setAttribute(this.el, 'data-dragging', '');
      });
      this.el.addEventListener('dragleave', e => {
        if (hasFiles(e) && depth > 0 && --depth === 0) this.reset();
      });

      this.reset = () => {
        depth = 0;
        this.js().removeAttribute(this.el, 'data-dragging');
      };
      window.addEventListener('drop', this.reset);
      window.addEventListener('dragend', this.reset);
    },

    destroyed() {
      window.removeEventListener('drop', this.reset);
      window.removeEventListener('dragend', this.reset);
    },
  },
};
